<template>
  <v-app id="inspire">

    <!-- Link to the Overview Page -->
    <v-navigation-drawer v-model="drawer" app>
      <v-list dense>
        <a href="/docs/index.html">
          <v-list-item link>
            <v-list-item-title>Project Documentation</v-list-item-title>
          </v-list-item>
        </a>
      </v-list>

      <!-- FIXME: Not sure what this section is doing, so it is commented out for now -->
      <!--
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item link>
          <v-list-item-action>
            <v-icon>mdi-bookshelf</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>All records</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      -->

      <v-treeview
        dense
        activatable
        hoverable
        :items="treeView"
        :active="activeNodes"
        @update:active="test"
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon v-if="item.isBook">{{ open ? 'mdi-book-open-page-variant' : 'mdi-book' }}</v-icon>
        </template>
      </v-treeview>
    </v-navigation-drawer>

    <!--v-app-bar app color="blue" dark-->
    <v-app-bar app style="color: white;" img src="PoorhouseSiteRibbon.jpg" prominent>
      <v-app-bar-nav-icon style="color: white;" @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <span class="font-weight-bold">{{ currentBook.BookName }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
      <v-btn icon style="color: white;" v-on:click="showSettingsDialog = true">
        <v-icon>mdi-account-cog</v-icon>
      </v-btn>
    </v-app-bar>
    <SettingsDialog v-if="showSettingsDialog" @close="showSettingsDialog = false"/>

    <!-- Show the current page image -->
    <!--<img :src=currentPage.Images[currentVersion].Url1024x768 width="100%" v-if="currentPage.Images.length > 0">-->
    <progressive-img
      :src="currentPage.Images[currentVersion].UrlFull"
      :placeholder="currentPage.Images[currentVersion].Url1024x768"
      v-if="currentPage.Images.length > 0"
      :blur="0"
      width="100%"
    />
    <!--<vue-magnifier :src="currentPage.Images[currentVersion].UrlFull" :src-large="currentPage.Images[currentVersion].UrlFull"></vue-magnifier>-->

    <!-- Show the current page extended transcription -->
    <!--
    <p>Using v-html directive: <span v-html="currentPage.ExtendedTranscription[currentVersion].Url"></span></p>
    <span v-once>This will never change: {{ "currentPage.ExtendedTranscription[currentVersion].Url" }}</span>
    <span v-once>This will never change: {{ <a href="basedir/Pages_0001-0009/Page_0001_ExtendedTranscription.html"></a> }}</span>
    <p>Using v-html directive: <span v-html="currentPage.ExtendedTranscription[currentVersion].Url"></span>"basedir/Pages_0001-0009/Page_0001_ExtendedTranscription.html"</p>
    <p><span v-html="currentPage.ExtendedTranscription[currentVersion].Url">"currentPage.ExtendedTranscription[currentVersion].Url"</span></p>
    -->

    <v-footer style="color: white;" color="green" app>
      <span class="font-weight-bold">{{ currentPage.DisplayPageTitle }}</span>
      <span v-if="currentPage.Images.length > 1">
        -
        <span class="font-weight-light">View {{currentVersion + 1 }} of {{currentPage.Images.length}}</span>
      </span>
    </v-footer>

  </v-app>
</template>

<script>
import "isomorphic-fetch";
import Vue from "vue";
import VueProgressiveImage from "vue-progressive-image";
import SettingsDialog from './SettingsDialog'

Vue.use(VueProgressiveImage);

export default {
  components: {
    'SettingsDialog': SettingsDialog
  },

  props: {
    source: String
  },

  data: () => ({
    showSettingsDialog: false,
    drawer: null,
    resources: Object,
    currentIndex: 0,
    menuHidden: true,
    currentPage: { DisplayPageTitle: "Loading...", Images: [] },
    currentPageIndex: 0,
    currentVersion: 0,
    currentBook: { BookName: "Loading..." },
    testMessage: null,
    loaded: false,
    items: [],
    treeView: [],
    activeNodes: [1],
    staticListItems: [
      {
        icon: "home",
        text: "Project Documentation"
      }
    ]
  }),

  mounted: function() {
    // Initialize the app with the data
    console.log("Loading the data");
    var dataUrl = "/resources.json";
    fetch(dataUrl)
      .then(resp => resp.json())
      .then(json => {
        console.log("Resources Loaded:", json);

        this.resources = json;
        this.loaded = true;

        // create the tree node view
        // Seems like there should be a better way that creating a new structure for the tree...
        /*
              Example Format
              [
              {
                id: 1,
                name: 'Poor House Record :',
                children: [
                  { id: 2, name: 'Page i' },
                  { id: 3, name: 'Page ii' },
                  { id: 4, name: 'Page iii' },
                ],
              },
            ],*/
        this.treeView = [];
        //var idNumber = 0;
        for (var n = 0; n < this.resources.length; n++) {
          var bookTreeItem = new Object();
          var book = this.resources[n];

          bookTreeItem.name = book.BookName;
          //bookTreeItem.id = idNumber++;
          bookTreeItem.isBook = true;
          bookTreeItem.id = book.Id;
          var bookChildren = [];

          for (var pNumber = 0; pNumber < book.Pages.length; pNumber++) {
            var pageItem = new Object();
            pageItem.name = book.Pages[pNumber].DisplayPageTitle;
            //pageItem.id = idNumber++;
            //bookTreeItem.isBook = false;
            pageItem.id = book.Pages[pNumber].Id;

            pageItem.page = book.Pages[pNumber];
            bookChildren.push(pageItem);
          }
          bookTreeItem.children = bookChildren;
          this.treeView.push(bookTreeItem);
        }

        // default to first page of first book
        if (this.resources.length > 0) {
          this.currentBook = this.resources[0];
          if (this.currentBook.Pages.length > 0) {
            this.currentPage = this.currentBook.Pages[this.currentPageIndex];
            this.activeNodes = [this.currentPage.Id];
          }
        }
      });

    document.addEventListener("keydown", this.handleKey);
  },

  methods: {

      test(items) {
      // get tree Node from index
      console.log("items", items);
      console.log("activeNodes: ", this.activeNodes);
      this.activeNodes = items;
      var modifiedNode = null;
      for (
        var bookNodeIndex = 0;
        bookNodeIndex < this.treeView.length;
        bookNodeIndex++
      ) {
        var node = this.treeView[bookNodeIndex].children.find(
          node => node.id == items[0]
        );
        if (node != undefined) {
          modifiedNode = node;
        }
      }

      // FIXME: Definitely need to redo this
      // we need to get the page offset

      for (
        var tempBookNodeIndex = 0;
        tempBookNodeIndex < this.treeView.length;
        tempBookNodeIndex++
      ) {
        for (
          var pageIndex = 0;
          pageIndex < this.resources[tempBookNodeIndex].Pages.length;
          pageIndex++
        ) {
          if (
            items[0] == this.resources[tempBookNodeIndex].Pages[pageIndex].Id
          ) {
            console.log("Found Id at index: " + pageIndex);
            this.currentPageIndex = pageIndex;
            this.currentBook = this.resources[tempBookNodeIndex];
            this.currentVersion = 0; // reset to the first version
          }
        }
      }

      if (modifiedNode != undefined) {
        this.currentPage = modifiedNode.page;
        this.currentVersion = 0; // reset to the first version
      } else {
        console.log("Failed to find node");
      }
    },

    handleKey: function(e) {
      switch (e.keyCode) {
        case 37:
          console.log("page: " + this.currentPage.DisplayPageTitle);
          if (this.currentPageIndex > 0) {
            this.currentVersion = 0; // reset to the first version
            this.currentPageIndex--;
            this.currentPage = this.currentBook.Pages[this.currentPageIndex];

            // find next node and set it active
            //currentPage.id
            this.activeNodes = [this.currentPage.Id];
          }
          break;
        case 38:
          // up
          // add total to the current version so that the modules is never taken on a negative value
          this.currentVersion =
            (this.currentPage.Images.length + this.currentVersion - 1) %
            this.currentPage.Images.length;
          break;
        case 39:
          if (this.currentPageIndex < this.currentBook.Pages.length - 1) {
            this.currentVersion = 0; // reset to the first version
            this.currentPageIndex++;
            this.currentPage = this.currentBook.Pages[this.currentPageIndex];
          }
          this.activeNodes = [this.currentPage.Id];
          break;
        case 40:
          // down
          console.log(
            "version: " +
              this.currentVersion +
              "length: " +
              this.currentPage.Images.length
          );
          this.currentVersion =
            (this.currentVersion + 1) % this.currentPage.Images.length;
          break;
      }
    },
    loadBook: function(bookId) {
      this.currentBook = this.resources.find(book => book.Id == bookId);
      console.log("New book selected: ", this.currentBook);
      this.currentPage = this.currentBook.Pages[0];
      this.menuHidden = true;
    }
  }
};
</script>
